const Shell = () => (
  <div className="new-container-fluid lighter-background">
    <div className="products-shell-container">
      <div className="products-shell-header">
        <div className="products-shell-breadcrumb">
          <div className="shell-loader"></div>
        </div>
        <div className="top-content-block">
          <div className="shell-loader"></div>
        </div>
        <div className="sorters-block">
          <div className="shell-loader"></div>
        </div>
        <div className="facets-block">
          <div className="shell-loader"></div>
        </div>
      </div>

      <div className="products-shell-body">
        <div className="products-shell-filters">
          <ul className="products-shell-filter margin-bottom">
            <li><div className="shell-loader margin-bottom-small"></div></li>
            <li><div className="shell-loader"></div></li>
            <li><div className="shell-loader"></div></li>
            <li><div className="shell-loader"></div></li>
          </ul>

          <ul className="products-shell-filter margin-bottom">
            <li><div className="shell-loader margin-bottom-small"></div></li>
            <li><div className="shell-loader"></div></li>
            <li><div className="shell-loader"></div></li>
            <li><div className="shell-loader"></div></li>
          </ul>
        </div>

        <section className="products-shell">
          <div className="products-wrapper">
            <div className="shell-loader"></div>
            <div className="shell-loader"></div>
            <div className="shell-loader"></div>
          </div>
        </section>
      </div>
    </div>
  </div>
)

export default Shell
